import React from 'react'
import queryString from 'query-string'
import styled from 'styled-components'

const Img = styled.img`
  & img {
    padding: ${({ padding }) =>
      ({
        small: '7px',
        medium: '15px',
        large: '25px',
      }[padding])} !important;

    ${({ outlined }) => outlined && `border: 4px solid #ccc !important;`}
    ${({ rounded }) => rounded && `border-radius: 7px !important;`}
  }
`

export default ({
  as,
  outlined,
  rounded,
  src,
  fit,
  w,
  h,
  padding,
  style,
  className,
}) => (
  <Img
    as={as}
    {...{ padding, outlined, rounded, style, className }}
    src={`${src}?${queryString.stringify({ fit, w, h })}`}
  />
)
